<header>
  <div class="d-flex wizard-header">
    <h3 class="dialog-title">
      <fa-icon [icon]="['fas', 'wrench']" transform="shrink-3" class="dialog-title"></fa-icon>
      <span>&nbsp;{{ (dialogData.isNew ? 'create' : 'update') | translate }} {{ 'advance_report' | translate }}</span>
    </h3>
    <ng-container>
      <div class="ml-auto d-flex">
        <ul class="list-inline pull-right">
          <li class="list-inline-item">
            <button type="button" (click)="closeDialog('cancel')" class="btn ml-1 btn-primary"
              id="wizardCreateDashboardCancelDialog">
              <fa-icon [icon]="['fas', 'times']"></fa-icon>
              <span class="pl-1">{{ 'cancel' | translate }}</span>
            </button>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</header>
<hr>
<ng-container>
  <mat-dialog-content class="mobile-view-dialog">
    <mat-horizontal-stepper [linear]="true" class="creation-wizard-style" #stepper>
      <ng-template matStepperIcon="edit">
        <mat-icon>done</mat-icon>
      </ng-template>
      <mat-step [stepControl]="generalSetupForm">
        <form [formGroup]="generalSetupForm">
          <ng-template matStepLabel>{{ 'advance_report_lang.report_setup' | translate }}</ng-template>
          <div class="row mt-2">
            <div class="col-lg">
              <div>
                <label class="labels" for="name">
                  {{ 'advance_report_lang.name' | translate }}
                  <required-tag [hasSpace]="false"></required-tag>
                </label>
              </div>
              <div>
                <input formControlName="name" type="text" class="form-control font-size-11"
                  [ngClass]="{'is-invalid': generalSetupForm.controls['name']?.touched && generalSetupForm.controls['name']?.invalid}" />
                  <app-validation-messages [control]="generalSetupForm.get('name')">
                    <ng-template let-errorMessage>
                      <small class="text-danger">
                        {{ errorMessage }}
                      </small>
                    </ng-template>
                  </app-validation-messages>
              </div>
            </div>
            <div class="col-lg">
              <div>
                <label class="labels" for="module">
                  {{ 'module' | translate }}
                  <required-tag [hasSpace]="false"></required-tag>
                </label>
              </div>
              <div>
                <ng-container *ngIf="(moduleList$ | async)?.domains as moduleList">
                  <ng-select appendTo="body" formControlName="module" [items]="moduleList" [clearable]="false" bindValue="value" bindLabel="label"
                    [ngClass]="{'is-invalid': generalSetupForm.controls['module'].touched && generalSetupForm.controls['module'].invalid}"
                    class="font-size-11">

                    <ng-template ng-option-tmp let-item="item">
                      <span>{{ item.label }}</span>
                    </ng-template>

                    <ng-template ng-label-tmp let-item="item">
                      <span>{{ item.label }}</span>
                    </ng-template>

                  </ng-select>
                </ng-container>
                <app-validation-messages [control]="generalSetupForm.get('module')">
                  <ng-template let-errorMessage>
                    <small class="text-danger">
                      {{ errorMessage }}
                    </small>
                  </ng-template>
                </app-validation-messages>
              </div>
            </div>
            <div *ngIf="generalSetupForm.controls['module'].value && generalSetupForm.controls['module'].value === 'assets'" class="col-lg">
              <div>
                <label class="labels" for="asset_type">
                  {{ 'asset_type' | translate }}
                </label>
              </div>
              <div>
                <ng-select
                  appendTo="body"
                  formControlName="asset_type_id"
                  [items]="assetTypeList$ | async"
                  [clearable]="true"
                  [virtualScroll]="true"
                  [searchable]="true"
                  [loading]="isLoading$ | async"
                  bindValue="value"
                  bindLabel="label"
                  [ngClass]="{'is-invalid': generalSetupForm.controls['asset_type_id'].touched && generalSetupForm.controls['asset_type_id'].invalid}"
                  class="font-size-11"
                  (change)="loadAssetTypeFields($event)"
                  (search)="onSearch($event)"
                  (scrollToEnd)="onScrollToEnd()"
                >

                  <ng-template ng-option-tmp let-item="item">
                    <span translate>{{ item.label }}</span>
                  </ng-template>

                  <ng-template ng-label-tmp let-item="item">
                    <span translate>{{ item.label }}</span>
                  </ng-template>

                </ng-select>

                <app-validation-messages [control]="generalSetupForm.get('asset_type_id')">
                  <ng-template let-errorMessage>
                    <small class="text-danger">
                      {{ errorMessage }}
                    </small>
                  </ng-template>
                </app-validation-messages>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="pb-3">
                <input [formControl]="searchAvailableFields" type="text" class="form-control font-size-11" placeholder="{{ 'search' | translate }} {{ 'available_fields' | translate }}"   />
              </div>
              <div class="list-group sortable-field-list available-field-list border" #availableFieldsElem>
                <ng-container *ngFor="let item of availableFieldList;  let i = index; trackBy: trackFieldList">
                  <div *ngIf="i === 0 || item.relatedTable !== availableFieldList[i - 1].relatedTable" class="list-group-item py-0 list-group-item-dark d-flex justify-content-between align-items-center">
                    <b>{{ (item.relatedTable || generalSetupForm.controls['module'].value) | translate }}</b>
                  </div>
                  <div class="list-group-item py-0 d-flex justify-content-between align-items-center" [attr.data-model]="item.model">
                    {{ item.translated_label }}
                    <fa-icon [icon]="['fas', 'arrows-alt']" class="sortablejs-draggable-icon" aria-hidden="true"></fa-icon>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-lg-6" [ngClass]="{'mt-3': isMobile}">
              <div class="pb-3">
                <label class="labels d-flex justify-content-between align-items-center" for="fields">
                  {{ 'used_fields' | translate }}
                  <required-tag [hasSpace]="false"></required-tag>
                  <a href="javascript:void(0)" class="btn btn-danger btn-sm" (click)="removeField($event)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>&nbsp;{{ 'remove' | translate }} {{ 'all' | translate }}
                  </a>
                </label>
              </div>
              <div class="list-group sortable-field-list used-field-list border" #usedFieldsElem>
                <div
                  class="list-group-item py-0"
                  *ngFor="let model of selectedFields"
                  [attr.data-model]="model"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="drag-handle mr-3" style="cursor: grab;">
                      <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
                    </span>

                    <div class="input-group input-group-sm py-0">
                      <div class="input-group-prepend prepend-no-margin-right no-padding">
                        <span class="input-group-text used-fields-label used-fields-label">{{ getFieldTemplate(model)?.translated_label || '--' }}</span>
                      </div>
                      <input type="text" class="form-control used-fields-input" placeholder="{{ 'alias' | translate }}"
                        [ngModel]="fieldAliases.value[model]"
                        (ngModelChange)="syncFieldAliases(model, $event)"
                        [ngModelOptions]="{standalone: true}" />
                      <div class="input-group-append append-no-margin-left">
                        <button class="btn btn-danger used-fields-delete" type="button" (click)="removeField($event, model)">
                          <fa-icon [icon]="['fas', 'times']" aria-hidden="true"></fa-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-validation-messages [control]="generalSetupForm.get('fields')" [messages]="multiselectMessages">
                <ng-template let-errorMessage>
                  <small class="text-danger">
                    {{ errorMessage }}
                  </small>
                </ng-template>
              </app-validation-messages>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-9 col-md-12">
              <div>
                <label class="labels" for="filters">
                  {{ 'filters' | translate }}
                </label>
              </div>
              <div>
                <advanced-searchbox *ngIf='filterList' [openOnLoad]="false" [template]="filterList" [model]="generalSetupForm.get('filters').value"
                  placeholder="{{ 'advance_report_lang.input_filter' | translate }}"></advanced-searchbox>
              </div>
            </div>
            <div class="col-lg-3 col-md-12">
              <div>
                <label class="labels" for="show_in_dashboard">
                  {{ 'show_in_dashboard' | translate }}
                </label>
              </div>
              <div>
                <mat-slide-toggle formControlName="show_in_dashboard"></mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="row mt-2" [ngClass]="{'mt-2': isMobile}">
            <div class="col-lg-12">
              <button type="button" class="btn btn-primary btn-block btn-lg p-2"
                (click)="next(stepper, generalSetupForm)">
                <strong>{{ 'next' | translate }}</strong>
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="datapointSetupForm">
        <form [formGroup]="datapointSetupForm" id="datapoint-setup-form">
          <ng-template matStepLabel>{{ 'advance_report_lang.datapoint_setup' | translate }}</ng-template>
          <div formArrayName="datapoints" class="row">
            <div class="col-lg-12 scrollable-table">
              <table class="table table-bordered mt-3 mt-2 datapoints-table sortable-table-rows" width="100%">
                <thead>
                  <tr>
                    <th>{{ 'filter' | translate }}</th>
                    <th>{{ 'advance_report_lang.aggregation_type' | translate }}</th>
                    <th>{{ 'advance_report_lang.aggregated_field' | translate }}</th>
                    <th>{{ 'advance_report_lang.name' | translate }}</th>
                    <th class="text-center align-middle">
                      <a href="javascript:void(0)" class="btn btn-primary btn-sm" (click)="addDatapoint()">
                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>&nbsp;{{ 'add' | translate }}
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody #datapointsListElem>
                  <ng-container *ngFor="let datapoint of datapoints.controls; let datapointIndex=index">
                    <tr [formGroupName]="datapointIndex">
                      <td width="44%">
                        <advanced-searchbox *ngIf='filterList' [openOnLoad]="false" [template]="filterList" [model]="datapoint.get('filters').value"
                          placeholder="{{ 'advance_report_lang.input_filter' | translate }}"></advanced-searchbox>
                      </td>
                      <td width="15%">
                        <div>
                          <ng-select appendTo="body" formControlName="type" [items]="getAggregationTypes(aggregationTypeDatapoint)" [clearable]="false"
                            [searchable]="false"
                            [ngClass]="{'is-invalid': datapoint.controls['type']?.touched && datapoint.controls['type']?.invalid}"
                            class="font-size-11">
                            <ng-template ng-option-tmp let-item="item">
                              <span>{{ 'advance_report_lang.aggregation_types.' + item | translate }}</span>
                            </ng-template>

                            <ng-template ng-label-tmp let-item="item">
                              <span>{{ 'advance_report_lang.aggregation_types.' + item | translate }}</span>
                            </ng-template>

                          </ng-select>
                          <app-validation-messages [control]="datapoint.controls['type']">
                            <ng-template let-errorMessage>
                              <small class="text-danger">
                                {{ errorMessage }}
                              </small>
                            </ng-template>
                          </app-validation-messages>
                        </div>
                      </td>
                      <td width="15%">
                        <div *ngIf="datapoint.controls['type'].value && datapoint.controls['type'].value !== 'value_count'">
                          <ng-select appendTo="body" formControlName="field" [items]="numericFields" [clearable]="false"
                            bindLabel="translated_label" bindValue="model" placeholder="{{ 'field' | translate }}">
                          </ng-select>
                          <app-validation-messages [control]="datapoint.controls['field']">
                            <ng-template let-errorMessage>
                              <small class="text-danger">
                                {{ errorMessage }}
                              </small>
                            </ng-template>
                          </app-validation-messages>
                        </div>
                      </td>
                      <td width="20%">
                        <div>
                          <input formControlName="name" type="text" class="form-control font-size-11"
                            [ngClass]="{'is-invalid': datapoint.controls['name']?.touched && datapoint.controls['name']?.invalid}" />
                          <app-validation-messages [control]="datapoint.controls['name']">
                            <ng-template let-errorMessage>
                              <small class="text-danger">
                                {{ errorMessage }}
                              </small>
                            </ng-template>
                          </app-validation-messages>
                        </div>
                      </td>
                      <td width="6%" class="text-center">
                        <a href="javascript:void(0)" class="btn btn-danger btn-sm" (click)="removeDatapoint(datapointIndex)">
                          <fa-icon [icon]="['fas', 'minus']"></fa-icon>&nbsp;{{ 'remove' | translate }}
                        </a>
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="datapoints.controls.length === 0">
                    <td colspan="6"class="text-center">
                      <span class="no-content text-center">
                        <fa-icon [icon]="['far', 'exclamation-circle']"></fa-icon> {{ 'advance_report_lang.datapoint_empty' | translate }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <button class="btn btn-warning btn-block btn-lg p-2" matStepperPrevious>{{ 'back' | translate }}</button>
            </div>
            <div class="col-lg-6" [ngClass]="{'mt-2': isMobile}">
              <button type="button" class="btn btn-primary btn-block btn-lg p-2"
                (click)="next(stepper, datapointSetupForm)">
                <strong>{{ 'next' | translate }}</strong>
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="chartSetupForm">
        <form [formGroup]="chartSetupForm">
          <ng-template matStepLabel>{{ 'advance_report_lang.charts_setup' | translate }}</ng-template>
          <div formArrayName="chart_configs">
            <div *ngFor="let config of chartConfigForms.controls; let chartIndex=index">
              <div class="row mt-3">
                <div class="col-xs-6 col-md-6 form-group">
                  <strong>{{ 'advance_report_lang.chart' | translate }} {{ chartIndex + 1 }}</strong>
                </div>
                <div class="col-xs-6 col-md-6 form-group">
                  <a href="javascript:void(0)" class="btn btn-danger btn-sm float-right" (click)="removeChart(chartIndex)">
                    <fa-icon [icon]="['fas', 'minus']"></fa-icon>&nbsp;{{ 'advance_report_lang.remove_chart' | translate }}
                  </a>
                </div>
              </div>
              <div [formGroupName]="chartIndex" class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-3">
                      <div>
                        <label class="labels" for="grouping_type">
                          {{ 'advance_report_lang.grouping_type' | translate }}
                          <required-tag [hasSpace]="false"></required-tag>
                        </label>
                      </div>
                      <div>
                        <ng-select appendTo="body" formControlName="grouping_type" [items]="groupingTypes" [searchable]="false"
                          [ngClass]="{'is-invalid': config.controls['grouping_type']?.touched && config.controls['grouping_type']?.invalid}"
                          [clearable]="false" class="font-size-11">
                          <ng-template ng-option-tmp let-item="item">
                            <span>{{ 'advance_report_lang.grouping_types.' + item | translate }}</span>
                          </ng-template>

                          <ng-template ng-label-tmp let-item="item">
                            <span>{{ 'advance_report_lang.grouping_types.' + item | translate }}</span>
                          </ng-template>

                        </ng-select>
                        <app-validation-messages [control]="config.controls['grouping_type']">
                          <ng-template let-errorMessage>
                            <small class="text-danger">
                              {{ errorMessage }}
                            </small>
                          </ng-template>
                        </app-validation-messages>
                      </div>
                    </div>
                    <ng-container [ngSwitch]="config.controls['grouping_type'].value">
                      <ng-container *ngSwitchCase="'date_histogram'">
                        <div formGroupName="date_histogram" class="col-lg-3">
                          <div>
                            <label class="labels" for="field">
                              {{ 'field' | translate }}
                              <required-tag [hasSpace]="false"></required-tag>
                            </label>
                          </div>
                          <div>
                            <ng-select appendTo="body" formControlName="field" [items]="dateTimeFields" [clearable]="false"
                              bindLabel="translated_label" bindValue="model" placeholder="{{ 'advance_report_lang.datetime_field' | translate }}">
                            </ng-select>
                          </div>
                        </div>
                        <div formGroupName="date_histogram" class="col-lg-3">
                          <div>
                            <label class="labels" for="calendar_interval">
                              {{ 'advance_report_lang.calendar_interval' | translate }}
                              <required-tag [hasSpace]="false"></required-tag>
                            </label>
                          </div>
                          <div>
                            <ng-select appendTo="body" formControlName="calendar_interval" [items]="calendarInterval"
                              [clearable]="false" [searchable]="false" bindLabel="label">

                              <ng-template ng-option-tmp let-item="item">
                                <span>{{ item | translate }}</span>
                              </ng-template>

                              <ng-template ng-label-tmp let-item="item">
                                <span>{{ item | translate }}</span>
                              </ng-template>

                            </ng-select>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'histogram'">
                        <div formGroupName="histogram" class="col-lg-3">
                          <div>
                            <label class="labels" for="field">
                              {{ 'field' | translate }}
                              <required-tag [hasSpace]="false"></required-tag>
                            </label>
                          </div>
                          <div>
                            <ng-select appendTo="body" formControlName="field" [items]="numericFields" [clearable]="false"
                              bindLabel="translated_label" bindValue="model" placeholder="{{ 'advance_report_lang.numeric_field' | translate }}">
                            </ng-select>
                          </div>
                        </div>
                        <div formGroupName="histogram" class="col-lg-3">
                          <div>
                            <label class="labels" for="interval">
                              {{ 'advance_report_lang.interval' | translate }}
                              <required-tag [hasSpace]="false"></required-tag>&nbsp;
                              <fa-icon [icon]="['fas', 'info-circle']" class="change-pointer" matTooltip="{{ 'advance_report_lang.interval_tooltip' | translate }}"></fa-icon>
                            </label>
                          </div>
                          <div>
                            <input formControlName="interval" type="number"
                              class="form-control font-size-11"
                              [ngClass]="{'is-invalid': config.controls['histogram'].controls['interval']?.touched && config.controls['histogram'].controls['interval']?.invalid}"
                              disableScroll />
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'terms'">
                        <div formGroupName="terms" class="col-lg-3">
                          <div>
                            <label class="labels" for="field">
                              {{ 'field' | translate }}
                              <required-tag [hasSpace]="false"></required-tag>
                            </label>
                          </div>
                          <div>
                            <ng-select appendTo="body" formControlName="field" [items]="dropdownFields" [clearable]="false" bindLabel="translated_label"
                              bindValue="model">
                            </ng-select>
                          </div>
                        </div>
                        <div formGroupName="terms" class="col-lg-3">
                          <div>
                            <label class="labels" for="size">
                              {{ 'advance_report_lang.size' | translate }}
                              <required-tag [hasSpace]="false"></required-tag>
                            </label>
                          </div>
                          <div>
                            <input formControlName="size" type="number"
                              class="form-control font-size-11"
                              [ngClass]="{'is-invalid': config.controls['terms'].controls['size']?.touched && config.controls['terms'].controls['size']?.invalid}" />
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'filter_group'">
                        filter_group
                      </ng-container>
                    </ng-container>
                    <div class="col-lg-3">
                      <div>
                        <label class="labels" for="name">
                          {{ 'advance_report_lang.name' | translate }}
                          <required-tag [hasSpace]="false"></required-tag>
                        </label>
                      </div>
                      <div>
                        <input formControlName="name" type="text" class="form-control font-size-11"
                          [ngClass]="{'is-invalid': config.controls['name']?.touched && config.controls['name']?.invalid}" />
                        <app-validation-messages [control]="config.controls['name']">
                          <ng-template let-errorMessage>
                            <small class="text-danger">
                              {{ errorMessage }}
                            </small>
                          </ng-template>
                        </app-validation-messages>
                      </div>
                    </div>
                  </div>
                  <div formArrayName="datasets">
                    <table class="table table-bordered mt-3 mt-2 datasets-table" width="100%">
                      <thead>
                        <tr>
                          <th colspan="5" class="text-center">{{ 'advance_report_lang.datasets' | translate }}</th>
                          <th rowspan="2" class="text-center align-middle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-sm" (click)="addDataset(chartIndex)">
                              <fa-icon [icon]="['fas', 'plus']"></fa-icon>&nbsp;{{ 'add' | translate }}
                            </a>
                          </th>
                        </tr>
                        <tr>
                          <th>{{ 'advance_report_lang.aggregation_type' | translate }}</th>
                          <th>{{ 'advance_report_lang.aggregated_field' | translate }}</th>
                          <th>{{ 'advance_report_lang.name' | translate }}</th>
                          <th>{{ 'advance_report_lang.chart_type' | translate }}</th>
                          <th>{{ 'advance_report_lang.color' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let dataset of datasetForm(chartIndex).controls; let datasetIndex=index">
                          <tr [formGroupName]="datasetIndex">
                            <td width="22%">
                              <div>
                                <ng-select appendTo="body" formControlName="type" [items]="getAggregationTypes(aggregationType)" [clearable]="false"
                                  [searchable]="false"
                                  [ngClass]="{'is-invalid': dataset.controls['type']?.touched && dataset.controls['type']?.invalid}"
                                  class="font-size-11">
                                  <ng-template ng-option-tmp let-item="item">
                                    <span>{{ 'advance_report_lang.aggregation_types.' + item | translate }}</span>
                                  </ng-template>

                                  <ng-template ng-label-tmp let-item="item">
                                    <span>{{ 'advance_report_lang.aggregation_types.' + item | translate }}</span>
                                  </ng-template>

                                </ng-select>
                                <app-validation-messages [control]="dataset.controls['type']">
                                  <ng-template let-errorMessage>
                                    <small class="text-danger">
                                      {{ errorMessage }}
                                    </small>
                                  </ng-template>
                                </app-validation-messages>
                              </div>
                            </td>
                            <td width="22%">
                              <div *ngIf="
                                dataset.controls['type'].value && ['value_count', 'field'].includes(dataset.controls['type'].value) === false
                              ">
                                <ng-select appendTo="body" formControlName="field" [items]="numericFields" [clearable]="false"
                                  bindLabel="translated_label" bindValue="model" placeholder="{{ 'field' | translate }}">
                                </ng-select>
                                <app-validation-messages [control]="dataset.controls['field']">
                                  <ng-template let-errorMessage>
                                    <small class="text-danger">
                                      {{ errorMessage }}
                                    </small>
                                  </ng-template>
                                </app-validation-messages>
                              </div>
                              <div *ngIf="
                                dataset.controls['type'].value && dataset.controls['type'].value === 'field'
                              ">
                                <ng-select appendTo="body" formControlName="field" [items]="stackableFields" [clearable]="false"
                                  bindLabel="translated_label" bindValue="model" placeholder="{{ 'field' | translate }}">
                                </ng-select>
                                <app-validation-messages [control]="dataset.controls['field']">
                                  <ng-template let-errorMessage>
                                    <small class="text-danger">
                                      {{ errorMessage }}
                                    </small>
                                  </ng-template>
                                </app-validation-messages>
                              </div>
                            </td>
                            <td width="22%">
                              <div>
                                <input formControlName="name" type="text" class="form-control font-size-11"
                                  [ngClass]="{'is-invalid': dataset.controls['name']?.touched && dataset.controls['name']?.invalid}" />
                                <app-validation-messages [control]="dataset.controls['name']">
                                  <ng-template let-errorMessage>
                                    <small class="text-danger">
                                      {{ errorMessage }}
                                    </small>
                                  </ng-template>
                                </app-validation-messages>
                              </div>
                            </td>
                            <td width="22%">
                              <div>
                                <ng-select appendTo="body" formControlName="chart_type" [items]="chartTypes" [searchable]="false"
                                  [ngClass]="{'is-invalid': dataset.controls['chart_type']?.touched && dataset.controls['chart_type']?.invalid}"
                                  [clearable]="false" class="font-size-11">
                                  <ng-template ng-option-tmp let-item="item">
                                    <span>{{ 'advance_report_lang.chart_types.' + item | translate }}</span>
                                  </ng-template>

                                  <ng-template ng-label-tmp let-item="item">
                                    <span>{{ 'advance_report_lang.chart_types.' + item | translate }}</span>
                                  </ng-template>

                                </ng-select>
                                <app-validation-messages [control]="dataset.controls['chart_type']">
                                  <ng-template let-errorMessage>
                                    <small class="text-danger">
                                      {{ errorMessage }}
                                    </small>
                                  </ng-template>
                                </app-validation-messages>
                              </div>
                            </td>
                            <td width="4%" class="text-center">
                              <input type="color" formControlName="color" class="w-100" />
                            </td>
                            <td width="8%" class="text-center">
                              <a href="javascript:void(0)" class="btn btn-danger btn-sm" (click)="removeDataset(chartIndex, datasetIndex)">
                                <fa-icon [icon]="['fas', 'minus']"></fa-icon>&nbsp;{{ 'remove' | translate }}
                              </a>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div  class="row mt-2">
              <div class="col-xs-12 col-md-12 form-group text-center">
                <a href="javascript:void(0)" class="btn btn-primary" (click)="addChart()">
                  <fa-icon [icon]="['fas', 'plus']"></fa-icon>&nbsp;{{ 'advance_report_lang.add_chart' | translate }}
                </a>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <button class="btn btn-warning btn-block btn-lg p-2" matStepperPrevious>{{ 'back' | translate }}</button>
            </div>
            <div class="col-lg-6" [ngClass]="{'mt-2': isMobile}">
              <button type="button" class="btn btn-primary btn-block btn-lg p-2"
                (click)="next(stepper, chartSetupForm)">
                <strong>{{ 'next' | translate }}</strong>
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ 'preview' | translate }}</ng-template>
        <div *ngIf="departmentRestriction" class="d-flex border rounded mb-2">
          <div class="rounded-left p-2 flex-shrink-1 bg-primary text-light pl-4 pr-4 pt-3 pb-3">
            <div class="d-flex align-items-center h-100">
              <fa-icon [icon]="['fas', 'info-circle']" class="fa-lg" aria-hidden="true"></fa-icon>
            </div>
          </div>
          <div class="w-100 p-2 pl-4">
            <div class="d-flex align-items-center h-100">
              <div class="row">
                <div class="col-sx-12 col-md-12">
                  <div  class="info-size" [innerHTML]="'department_restriction_in_report' | translate"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="resultDatapoints?.length > 0" class="row mb-4">
          <div *ngFor="let datapoint of resultDatapoints" class="col-lg">
            <div class="p-2 border">
              <b>{{ datapoint.config.name }}</b>
              <div class="text-center my-5 text-primary font-weight-bold h3">
                {{ datapoint.aggregated_result.value }}
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf='dashboardData$ | async as dashboardData; else resultsetLoading'>
          <ng-container *ngIf="resultSet?.length > 0; else resultsetEmpty">
            <div class="row">
              <ng-container *ngFor="let chartOption of dashboardData; index as i">
                <div [ngClass]="dashboardData.length === i + 1 && i % 2 === 0 ? 'col-lg' : 'col-lg-6 col-md'">
                  <div *ngIf="chartOption" echarts [options]="chartOption" style="width: 100%; min-height: 400px;"></div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
        <div *ngIf="resultSet?.length > 0 && generalSetupForm.get('fields').value !== null" class="row mt-2 scrollable-table">
          <div class="col-lg-12">
            <fieldmagic-data-grid
              [columns]="columns"
              [options]="options"
              [data]="resultSet"
              [size]="'md'"
              (onReady)="initDataGrid($event)"
            ></fieldmagic-data-grid>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-6">
            <button class="btn btn-warning btn-block btn-lg p-2" matStepperPrevious>{{ 'back' | translate }}</button>
          </div>
          <div class="col-lg-6" [ngClass]="{'mt-2': isMobile}">
            <button type="button" class="btn btn-primary btn-block btn-lg p-2" (click)="saveDashboard()">
              <strong>{{ 'save' | translate }}</strong>
            </button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>
</ng-container>

<ng-template #resultsetLoading>
  <div class="row mt-2">
    <span class="no-content text-center">
      <inline-view-loader [isLoading]="true"></inline-view-loader> {{ 'loading' | translate }}
    </span>
  </div>
</ng-template>

<ng-template #resultsetEmpty>
  <div class="row mt-2">
    <span class="no-content text-center">
      <fa-icon [icon]="['far', 'exclamation-circle']"></fa-icon>{{ 'advance_report_lang.result_empty' | translate }}
    </span>
  </div>
</ng-template>
